export const cn = {
  'switch.on.text': '开',
  'switch.off.text': '关',
};
export const en = {
  'switch.on.text': 'On',
  'switch.off.text': 'Off',
};
